import PropTypes from 'prop-types';
import { Box } from 'roo-ui/components';
import QFFPointsItem from './QFFPointsItem';
import { H2 } from '../primitives';

const QFFPoints = ({ memberNumber, earnedPoints, awardedPoints }) =>
  !!memberNumber && (!!earnedPoints || !!awardedPoints) ? (
    <Box as="article">
      <H2>Qantas Frequent Flyer Points</H2>
      <QFFPointsItem memberNumber={memberNumber} earnedPoints={earnedPoints} awardedPoints={awardedPoints} />
    </Box>
  ) : null;

QFFPoints.propTypes = {
  memberNumber: PropTypes.string,
  earnedPoints: PropTypes.number,
  awardedPoints: PropTypes.number,
};

export default QFFPoints;
